// easyui-dialog.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, Output, ViewChild, EventEmitter, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-dialog',
  template: `
		<div #host>
			<ng-content></ng-content>
		</div>
	`
})
export class EasyuiDialogComponent implements AfterViewInit {
	private host: any;
	@ViewChild('host') hostElement: ElementRef;
	@Input('options') options: any = {};
	@Input('tipo') tipo = '';
	@Output() onbutton = new EventEmitter<string>();

	constructor() {
	}

	ngAfterViewInit() {
		this.configura(this.options);
	}

	public open(opts?: any) {
		this.host.dialog('open');
		if (opts && opts.top && opts.left) {
			this.host.dialog('resize', {top: opts.top, left: opts.left});
		}
	}

	public close() {
		this.host.dialog('close');
	}

	public center() {
		this.host.dialog('center');
	}

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
	}

	// private

	private configura(options: any) {
		if (this.tipo.toUpperCase().lastIndexOf('SINO') >= 0)  {
			this.host = $(this.hostElement.nativeElement);
			let localoptions = {
				width: 400,
				height: 200,
				closed: true,
				buttons: [
					{
						text: 'Sì', width: 55, handler: () => {
							this.onbutton.emit('si');
							this.close();
						}
					}
				]
			};

			localoptions.buttons.push({
				text: 'No',
				width: 65,
				handler: () => {
					this.onbutton.emit('no');
				}
			});
			localoptions = Object.assign(localoptions, options);
			this.host.dialog(localoptions);
			} else {
			this.host = $(this.hostElement.nativeElement);
			let localoptions = {
				width: 400,
				height: 200,
				closed: true,
				buttons: [
					{
						text: 'OK', width: 55, handler: () => {
							this.onbutton.emit('ok');
							this.close();
						}
					}
				]
			};
			if (this.tipo.toUpperCase().lastIndexOf('APPLICA') >= 0)  {
				localoptions.buttons.push({
					text: 'Applica',
					width: 65,
					handler: () => {
						this.onbutton.emit('applica');
					}
				});
			}
			if (this.tipo.toUpperCase().lastIndexOf('CHIUDI') >= 0)  {
				localoptions.buttons.push({
					text: 'Chiudi',
					width: 55,
					handler: () => {
						this.onbutton.emit('chiudi');
						this.close();
					}
				});
			}
			if (this.tipo.toUpperCase().lastIndexOf('ESCI') >= 0)  {
				localoptions.buttons.push({
					text: 'Esci',
					width: 55,
					handler: () => {
						this.onbutton.emit('esci');
						this.close();
					}
				});
			}

			localoptions = Object.assign(localoptions, options);
			this.host.dialog(localoptions);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-dialog.component.ts